


















































































import CCustomSelect from '~/components/shared/configurable/form/select/custom/CCustomSelect.vue'
import ForMakeModelSearchHandlerMixin from '~/components/car/classifieds/search/facets/handlers/MakeModel/ForMakeModelSearchHandlerMixin.vue'
import { defineComponent } from '~/utils/nuxt3-migration'
import { mapState } from 'vuex'
import { CLASSIFIED_SEARCH_NS } from '~/store/modules/shared/classifieds/search/state'

export default defineComponent({
  components: {
    CCustomSelect
  },
  mixins: [ForMakeModelSearchHandlerMixin],
  computed: {
    ...mapState(CLASSIFIED_SEARCH_NS, {
      loadingFacets: state => state.loading.facets
    })
  }
})
